module.exports = "<div gw-pl-binary-choice-group model=\"model\" label=\"{{label}}\"\r\n     title-left=\"{{'platform.inputs.Yes' | translate}}\"\r\n     title-right=\"{{'platform.inputs.No' | translate}}\"\r\n     value-left=\"true\"\r\n     value-right=\"false\"\r\n     ng-disabled=\"isDisabled()\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/inputs/templates/yes-no-group.html
// module id = 934
// module chunks = 0